import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'
import * as colors from '../../../constants/colors'

const ID = 'linktree-third-party-glyph-icon'

export function LinkTreeSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <g clipPath="url(#linktree-a)">
          <circle cx="16" cy="16" r="16" />
          <path
            fill={colors.PRIMARY_GREY_000}
            fillRule="evenodd"
            d="M14.78 19.507h2.49V25.1h-2.49v-5.594Z"
            clipRule="evenodd"
          />
          <path
            fill={colors.PRIMARY_GREY_000}
            fillRule="evenodd"
            d="M9.026 13.78h4.23l-3.011-2.85 1.659-1.69 2.865 2.93V8h2.489v4.168l2.864-2.93 1.659 1.691-3.011 2.85H23v2.358h-4.257l3.025 2.93-1.66 1.652L16 16.603l-4.109 4.116-1.66-1.652 3.026-2.93H9V13.78h.026Z"
            clipRule="evenodd"
          />
        </g>
        <defs>
          <clipPath id="linktree-a">
            <path fill={colors.PRIMARY_GREY_000} d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </g>
    </symbol>
  )
}

const LinkTreeStandaloneContent = standalone(LinkTreeSymbol, ID)

export const Linktree = styled(function LinkTreeStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-linktree">
      <LinkTreeStandaloneContent />
    </Icon>
  )
})``

export const LinktreeLightweight = styled(function LinkTreeComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-linktree">
      {lightweight(ID)}
    </Icon>
  )
})``
